import React, {useEffect} from "react";
import { makeStyles } from '@mui/styles';
import clsx from "clsx";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import WOW from "wow.js";

const useStyles = makeStyles({
    wrapper: {
        minHeight: "100%",
        position: "relative",
    },
    footer: {
        position: "absolute",
        width: "100%",
        bottom: 10,
    }
})

const MainLayout = ({children, contentClassName, footerClassName}) => {
    const classes = useStyles();

    useEffect(() => {
        new WOW().init();
        window.scrollTo(0, 0);
    },[]);

    return (
        <div className={classes.wrapper}>
            <div className={clsx(classes.content, contentClassName)}>
                <Menu />
                {children}
            </div>
            <div className={clsx(classes.footer, footerClassName)}>
                <Footer />
            </div>
        </div>
    )
}

export default MainLayout;
